import _extends from 'babel-runtime/helpers/extends';

import { linkageMixin } from '../mixin/linkage';
import { mapMutations } from 'vuex';
import useIdToFindCategory from '../utils/use-id-to-find-category';
import globalEventBus, { events } from '@/event';
import { isGroup } from './menu-sort-dialog/tree.js';
import CategoryMirrorBtn from '@/views/creative/template/category-mirror-btn.vue';

export default {
  components: { CategoryMirrorBtn: CategoryMirrorBtn },
  mixins: [linkageMixin],

  props: {
    category: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      step: '',
      name: ''
    };
  },


  computed: {
    tipsContent: function tipsContent() {
      return this.$t('playTurbo.creative.categoryConfig.linkage') + this.linkageCategoryText;
    }
  },

  methods: _extends({}, mapMutations({
    updateActiveCategoryId: 'creative/template/updateActiveCategoryId',
    updateActiveCategoryNode: 'creative/template/updateActiveCategoryNode'
  }), {
    findParentSceneCategory: function findParentSceneCategory(id) {
      var _this = this;

      var category = useIdToFindCategory({
        category: this.templateConfig.category,
        categoryId: id
      });
      var findParentScene = function findParentScene(category) {
        if (category.pid === 9) {
          return category;
        }
        if (category.pid === 8) {
          return useIdToFindCategory({
            category: _this.templateConfig.category,
            categoryId: category.pid
          });
        }
        return findParentScene(useIdToFindCategory({
          category: _this.templateConfig.category,
          categoryId: category.pid
        }));
      };
      return findParentScene(category);
    },
    navigateToRefCategory: function navigateToRefCategory() {
      var _this2 = this;

      var refIds = this.allRefCategory;
      var nextRefId = refIds[refIds.findIndex(function (item) {
        return item === _this2.category.id;
      }) + 1] || refIds[0];
      if (!nextRefId) return;

      // 检查当前跳转关联节点是否在组内，组内关联节点跳转到对应所属组节点位置
      var category = useIdToFindCategory({
        category: this.templateConfig.category,
        categoryId: nextRefId
      });
      var parent = useIdToFindCategory({
        category: this.templateConfig.category,
        categoryId: category.pid
      });

      if (isGroup(parent)) {
        nextRefId = parent.id;
      }

      var data = {};
      data.id = nextRefId;
      if (this.isV2) {
        var sceneNode = this.findParentSceneCategory(nextRefId);
        this.updateActiveCategoryId(sceneNode.id);
        this.updateActiveCategoryNode(sceneNode);
        data.sceneId = sceneNode.id;
      } else {
        this.updateActiveCategoryId(nextRefId);
        this.updateActiveCategoryNode(useIdToFindCategory({
          category: this.templateConfig.category,
          categoryId: nextRefId
        }));
      }

      // 加 $nextTick 是为了执行 outline/navigate 事件回调函数的动画
      this.$nextTick(function () {
        globalEventBus.$emit(events.DM.OUTLINE.NAVIGATE, data);
      });
    }
  })
};